import(/* webpackMode: "eager" */ "/home/runner/work/examanet/examanet/src/app/global-error.tsx");
